import { useEffect, useState } from "react";
import { SITE } from "../constants/site";

const target = new Date(SITE.launchDate).getTime();

function parts() {
  const diff = Math.max(0, target - Date.now());
  return [
    ["Days", Math.floor(diff / 86400000)],
    ["Hrs", Math.floor(diff / 3600000) % 24],
    ["Min", Math.floor(diff / 60000) % 60],
    ["Sec", Math.floor(diff / 1000) % 60],
  ];
}

export default function Countdown() {
  const [t, setT] = useState(parts());
  useEffect(() => {
    const i = setInterval(() => setT(parts()), 1000);
    return () => clearInterval(i);
  }, []);

  if (target <= Date.now()) {
    return (
      <div data-testid="launch-countdown" className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 w-full">
        <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-[#25D366] animate-pulse" />
          Sugee Lake District
        </p>
        <div className="flex items-baseline gap-4">
          <p className="font-display text-3xl md:text-4xl text-primary">Now Launched</p>
          <p className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">Final inventory open</p>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="launch-countdown" className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 w-full">
      <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-[#25D366] animate-pulse" />
        Pre-launch pricing ends in
      </p>
      <div className="flex gap-3">
        {t.map(([label, v]) => (
          <div key={label} className="border border-border px-4 py-3 text-center min-w-[70px] bg-white">
            <p className="font-display text-3xl text-primary tabular-nums">{String(v).padStart(2, "0")}</p>
            <p className="text-[9px] uppercase tracking-[0.3em] text-muted-foreground mt-1">{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
